import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Checked = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 44",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "22",
                cy: "22",
                r: "18",
                fill: "#FFDF00"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "8",
                y: "8",
                width: "28",
                height: "28",
                rx: "14",
                fill: "#FFDF00"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.1667 28.2332L13.5 22.5665L15.4833 20.5832L19.1667 24.2665L28.5167 14.9165L30.5 16.8998L19.1667 28.2332Z",
                fill: "white"
            })
        ]
    }));
};
